<template>
	<div class="content">
		<div id="pdfDom" ref="pdf" class="export">
			<div class="home">
				<div class="htitle">{{cepingren.company}}</div>
				<div class="com-x">
					<span class="q">企业类型</span><span>：</span><span
						class="com-span1">{{ cepingren.enterprise_years}}</span><br><br>
					<span class="z">组织诊断人</span><span>：</span><span
						class="com-span1">{{ cepingren.user_name }}</span><br><br>
					<span class="t">日期</span><span>：</span><span class="com-span1">{{ timeaa }}</span>
				</div>
			</div>
			<div>
				<div
					style="display: flex;flex-direction: column;justify-content: space-around;align-items: center;height: calc(722mm - 240px);padding:120px;">
					<div class="toptile">股权5D核心战略诊断</div>
					<div class="text" v-html="text"></div>
					<div class="tubiao">
						<div class="t_left">
							<el-table :data="dlist" border style="width: 100%">
								<el-table-column prop="xc" label="项目" width="180">
								</el-table-column>
								<el-table-column prop="zong" label="标准分数" width="180">
								</el-table-column>
								<el-table-column prop="fenshu" label="实际分数">
								</el-table-column>
							</el-table>
						</div>
						<div id="ec" style="width: 60%;height: 600px;border: 5px solid #000;"></div>
					</div>
				</div>
				<div class="ctubiao">
					<div class="toptile ma">股权5D战术诊断分析图表</div>
					<div class="tubiao">
						<div class="t_left">
							<el-table :data="clists" border style="width: 100%">
								<el-table-column prop="xm" label="项目" width="180">
								</el-table-column>
								<el-table-column prop="zong" label="标准分数" width="180">
								</el-table-column>
								<el-table-column prop="fenshu" label="实际分数">
								</el-table-column>
							</el-table>
						</div>
						<div id="ecs" style="width: 60%;height: 600px;border: 5px solid #000;"></div>
					</div>
					<el-table :data="clist" border style="width: 100%">
						<el-table-column type="index" width="90" label="项次">
						</el-table-column>
						<el-table-column prop="xc" label="内容" width="180">
						</el-table-column>
						<el-table-column prop="zong" label="标准分" width="180">
						</el-table-column>
						<el-table-column prop="fenshu" label="实况分">
						</el-table-column>
						<el-table-column prop="type" label="改进方式">
						</el-table-column>
					</el-table>
					<div
						style="border-bottom: 1px solid #000000;border-left: 1px solid #000000;border-right: 1px solid #000000;padding: 8px 16px;font-size: 22px;">
						本次诊断总计得分：{{zong}}分
					</div>
				</div>
			</div>
			<div class="ctubiao list">
				<div style="font-size: 36px;font-weight: bold;text-align: center;padding-bottom: 32px;">股权5D 新赛道布局工具包
				</div>
				<div class="bte">经过战略和战术诊断后，<span class="t1">{{cepingren.company}}</span>属于<span
						class="t2">{{cepingren.service_type}}</span>行业、<span
						class="t3">{{cepingren.enterprise_years}}</span>型公司，公司在股投、股改布局时需要按照相应的要求进行以下文案：</div>
				<el-table :data="biao" border style="width: 100%"
					v-if="cepingren.enterprise_years == '初创(设想)' && cepingren.service_type == '服务业'">
					<el-table-column type="index" label="序号" width="90">
					</el-table-column>
					<el-table-column prop="xc" label="方案及文件清单目录" width="360">
					</el-table-column>
					<el-table-column prop="zong" label="布局中作用" width="360">
					</el-table-column>
					<el-table-column prop="fenshu" label="备注" width="180">
					</el-table-column>
				</el-table>
				<el-table :data="biao2" border style="width: 100%"
					v-if="cepingren.enterprise_years == '初创(设想)' && cepingren.service_type == '高科技'">
					<el-table-column type="index" label="序号" width="90">
					</el-table-column>
					<el-table-column prop="xc" label="方案及文件清单目录" width="360">
					</el-table-column>
					<el-table-column prop="zong" label="布局中作用" width="360">
					</el-table-column>
					<el-table-column prop="fenshu" label="备注" width="180">
					</el-table-column>
				</el-table>
				<el-table :data="biao3" border style="width: 100%"
					v-if="cepingren.enterprise_years == '初创(设想)' && cepingren.service_type == '传统行业'">
					<el-table-column type="index" label="序号" width="90">
					</el-table-column>
					<el-table-column prop="xc" label="方案及文件清单目录" width="360">
					</el-table-column>
					<el-table-column prop="zong" label="布局中作用" width="360">
					</el-table-column>
					<el-table-column prop="fenshu" label="备注" width="180">
					</el-table-column>
				</el-table>
				<el-table :data="biao4" border style="width: 100%"
					v-if="cepingren.enterprise_years == '经营3年以下' && cepingren.service_type == '传统行业'">
					<el-table-column type="index" label="序号" width="90">
					</el-table-column>
					<el-table-column prop="xc" label="方案及文件清单目录" width="360">
					</el-table-column>
					<el-table-column prop="zong" label="布局中作用" width="360">
					</el-table-column>
					<el-table-column prop="fenshu" label="备注" width="180">
					</el-table-column>
				</el-table>
				<el-table :data="biao5" border style="width: 100%"
					v-if="cepingren.enterprise_years == '经营3年以下' && cepingren.service_type == '服务业'">
					<el-table-column type="index" label="序号" width="90">
					</el-table-column>
					<el-table-column prop="xc" label="方案及文件清单目录" width="360">
					</el-table-column>
					<el-table-column prop="zong" label="布局中作用" width="360">
					</el-table-column>
					<el-table-column prop="fenshu" label="备注" width="180">
					</el-table-column>
				</el-table>
				<el-table :data="biao6" border style="width: 100%"
					v-if="cepingren.enterprise_years == '经营3年以下' && cepingren.service_type == '高科技'">
					<el-table-column type="index" label="序号" width="90">
					</el-table-column>
					<el-table-column prop="xc" label="方案及文件清单目录" width="360">
					</el-table-column>
					<el-table-column prop="zong" label="布局中作用" width="360">
					</el-table-column>
					<el-table-column prop="fenshu" label="备注" width="180">
					</el-table-column>
				</el-table>
				<el-table :data="biao4" border style="width: 100%"
					v-if="cepingren.enterprise_years == '经营3年以上' && cepingren.service_type == '传统行业'">
					<el-table-column type="index" label="序号" width="90">
					</el-table-column>
					<el-table-column prop="xc" label="方案及文件清单目录" width="360">
					</el-table-column>
					<el-table-column prop="zong" label="布局中作用" width="360">
					</el-table-column>
					<el-table-column prop="fenshu" label="备注" width="180">
					</el-table-column>
				</el-table>
				<el-table :data="biao5" border style="width: 100%"
					v-if="cepingren.enterprise_years == '经营3年以上' && cepingren.service_type == '服务业'">
					<el-table-column type="index" label="序号" width="90">
					</el-table-column>
					<el-table-column prop="xc" label="方案及文件清单目录" width="360">
					</el-table-column>
					<el-table-column prop="zong" label="布局中作用" width="360">
					</el-table-column>
					<el-table-column prop="fenshu" label="备注" width="180">
					</el-table-column>
				</el-table>
				<el-table :data="biao6" border style="width: 100%"
					v-if="cepingren.enterprise_years == '经营3年以上' && cepingren.service_type == '高科技'">
					<el-table-column type="index" label="序号" width="90">
					</el-table-column>
					<el-table-column prop="xc" label="方案及文件清单目录" width="360">
					</el-table-column>
					<el-table-column prop="zong" label="布局中作用" width="360">
					</el-table-column>
					<el-table-column prop="fenshu" label="备注" width="180">
					</el-table-column>
				</el-table>
				<div
					style="border-bottom: 1px solid #000000;border-left: 1px solid #000000;border-right: 1px solid #000000;padding: 8px 16px;font-size: 22px;">
					由于行业类型不同，内容不断更新，属于公司核心机密，具体工具包要重新领取！
				</div>
			</div>
			<div class="wei"></div>
		</div>
<!--		<button @click="generate()">生成</button>-->
	</div>
</template>

<script>
	import * as echarts from "echarts";
	var indexurl = localStorage.getItem('url')
	let loading
	export default {
		data() {
			return {
				urlCode: '',
				dlist: [],
				clist: [],
				text: '',
				clists: [],
				zong: '',
				timeaa: '',
				cepingren: {},
				biao: [{
					xc: '服务/项目六宫格品牌定位法',
					zong: '决定企业方向与股权生命持续性',
					fenshu: '分析表'
				}, {
					xc: '合伙人测评',
					zong: '股权牢固的基础，投资可靠性保证。',
					fenshu: '软件'
				}, {
					xc: '合伙人要素评估',
					zong: '股权分配公平性、激励的高效性',
					fenshu: '评估表'
				}, {
					xc: '股权5D新赛道启动仪式',
					zong: '股权：造势、宣传、保障、激励、提升',
					fenshu: '流程'
				}, {
					xc: '战略设计—公司名称',
					zong: '行业有关、减少推广费和节省推广时间',
					fenshu: '高端生态'
				}, {
					xc: '战略设计—产品品牌',
					zong: '使用对象有关，消费者认知和品牌下沉',
					fenshu: '亲和、有磁场'
				}, {
					xc: '战略设计—产品渠道',
					zong: '快速铺垫销售管道，变现和销售增长',
					fenshu: '门店、代理'
				}, {
					xc: '战略设计—给客户创造价值',
					zong: '快速增长、盈利快，激发股东认同',
					fenshu: '刚需、必须'
				}, {
					xc: '股东个人尽职调查',
					zong: '画像形成，关键人股份分配合理性',
					fenshu: '表单'
				}, {
					xc: '股权结构',
					zong: '明确股权分配，了解过去、未来股权状',
					fenshu: '分配表'
				}, {
					xc: '商业计划书',
					zong: '吸引投资及内部关键人才，明确方向',
					fenshu: '指导方案'
				}, {
					xc: '股权九条红线运用表',
					zong: '创始人维护自己的正当权力，经营保障',
					fenshu: '提炼表'
				}, {
					xc: '对赌方案',
					zong: '确保入股股东的权益有一个安全的保障',
					fenshu: '方案表'
				}, {
					xc: 'AB股运用方案',
					zong: '创始人股权合规保障，促进组织发展',
					fenshu: '法规条文'
				}, {
					xc: '干股激励协议书',
					zong: '保证干股中管理、技术关键人潜力发挥',
					fenshu: '文本'
				}, {
					xc: '新进高管股权激励办法',
					zong: '引进合适人才，解决组织经营发展问题',
					fenshu: '文本'
				}, {
					xc: '保密协议',
					zong: '解决股权不便公开机密的保密性措施',
					fenshu: '文本'
				}, {
					xc: '竞业协议',
					zong: '避免内股东特权损害公司利益（20%）',
					fenshu: '文本'
				}, {
					xc: '股权激励计划管理制度',
					zong: '将股权激励与经营管理的融合目标管理',
					fenshu: '文本'
				}, {
					xc: '激励对象承诺书',
					zong: '确保参与股东和公司的遵循的准则',
					fenshu: '文本'
				}, {
					xc: '激励对象行权或解锁申请书',
					zong: '股权股份得到尊重，股权行权规范化',
					fenshu: '文本'
				}, {
					xc: '股东激励大会',
					zong: '股东承诺和结果认可，引领他人参与',
					fenshu: '文本'
				}, {
					xc: '公司章程',
					zong: '公司成立的法规性、可操作性',
					fenshu: '文本'
				}, {
					xc: '公司章程修改建议书',
					zong: '体现股权在章程中权威性及法律性',
					fenshu: '文本'
				}, {
					xc: '《股权赠与协议》',
					zong: '股权“稀释”的规范性和法律重要性',
					fenshu: '文本'
				}, {
					xc: '股东进入、分红及退出机制',
					zong: '保障公司在一定时间内健康运行',
					fenshu: '文本'
				}, {
					xc: '股权计划设计方案',
					zong: '股权构想和现实差距与解决问题的方法',
					fenshu: '文本'
				}, {
					xc: '董事会规则',
					zong: '突显股权是象征性，为组织经营服务',
					fenshu: '文本'
				}, {
					xc: '全面激励计划',
					zong: '股权在公司的作用，组织的责任与担当',
					fenshu: '文本'
				}, {
					xc: '中华人民共和国公司法',
					zong: '股权解释，组织和股东的权益和义务',
					fenshu: '法规条文'
				}, {
					xc: '年度目标达成方案',
					zong: '股圈目标分解以及完成的方向性活动',
					fenshu: '文本'
				}, {
					xc: '项目达成方案',
					zong: '股权从个案开始，体现股权的长期效果',
					fenshu: '文本'
				}, {
					xc: '目标绩效与考核方案',
					zong: '保障股东更稳定、组织持续发展',
					fenshu: '文本'
				}, {
					xc: '------',
					zong: '依组织过去、现状、未来发展进行增减',
					fenshu: ''
				}],
				biao2: [{
					xc: '服务/项目六宫格品牌定位法',
					zong: '决定企业方向与股权生命持续性',
					fenshu: '分析表'
				}, {
					xc: '合伙人测评',
					zong: '股权牢固的基础，投资可靠性保证。',
					fenshu: '软件'
				}, {
					xc: '合伙人要素评估',
					zong: '股权分配公平性、激励的高效性',
					fenshu: '评估表'
				}, {
					xc: '股权5D新赛道启动仪式',
					zong: '股权：造势、宣传、保障、激励、提升',
					fenshu: '流程'
				}, {
					xc: '战略设计—公司名称',
					zong: '行业有关、减少推广费和节省推广时间',
					fenshu: '高端生态'
				}, {
					xc: '战略设计—产品品牌',
					zong: '使用对象有关，消费者认知和品牌下沉',
					fenshu: '亲和、有磁场'
				}, {
					xc: '战略设计—产品渠道',
					zong: '快速铺垫销售管道，变现和销售增长',
					fenshu: '门店、代理'
				}, {
					xc: '战略设计—给客户创造价值',
					zong: '快速增长、盈利快，激发股东认同',
					fenshu: '刚需、必须'
				}, {
					xc: '股东个人尽职调查',
					zong: '画像形成，关键人股份分配合理性',
					fenshu: '表单'
				}, {
					xc: '股权结构',
					zong: '明确股权分配，了解过去、未来股权状',
					fenshu: '分配表'
				}, {
					xc: '商业计划书',
					zong: '吸引投资及内部关键人才，明确方向',
					fenshu: '指导方案'
				}, {
					xc: '股权九条红线运用表',
					zong: '创始人维护自己的正当权力，经营保障',
					fenshu: '提炼表'
				}, {
					xc: '对赌方案',
					zong: '确保入股股东的权益有一个安全的保障',
					fenshu: '方案表'
				}, {
					xc: 'AB股运用方案',
					zong: '创始人股权合规保障，促进组织发展',
					fenshu: '法规条文'
				}, {
					xc: '干股激励协议书',
					zong: '保证干股中管理、技术关键人潜力发挥',
					fenshu: '文本'
				}, {
					xc: '新进高管股权激励办法',
					zong: '引进合适人才，解决组织经营发展问题',
					fenshu: '文本'
				}, {
					xc: '保密协议',
					zong: '解决股权不便公开机密的保密性措施',
					fenshu: '文本'
				}, {
					xc: '竞业协议',
					zong: '避免内股东特权损害公司利益（20%）',
					fenshu: '文本'
				}, {
					xc: '股权激励计划管理制度',
					zong: '将股权激励与经营管理的融合目标管理',
					fenshu: '文本'
				}, {
					xc: '激励对象承诺书',
					zong: '确保参与股东和公司的遵循的准则',
					fenshu: '文本'
				}, {
					xc: '激励对象行权或解锁申请书',
					zong: '股权股份得到尊重，股权行权规范化',
					fenshu: '文本'
				}, {
					xc: '股东激励大会',
					zong: '股东承诺和结果认可，引领他人参与',
					fenshu: '文本'
				}, {
					xc: '公司章程',
					zong: '公司成立的法规性、可操作性',
					fenshu: '文本'
				}, {
					xc: '公司章程修改建议书',
					zong: '体现股权在章程中权威性及法律性',
					fenshu: '文本'
				}, {
					xc: '《股权赠与协议》',
					zong: '股权“稀释”的规范性和法律重要性',
					fenshu: '文本'
				}, {
					xc: '股东进入、分红及退出机制',
					zong: '保障公司在一定时间内健康运行',
					fenshu: '文本'
				}, {
					xc: '股权计划设计方案',
					zong: '股权构想和现实差距与解决问题的方法',
					fenshu: '文本'
				}, {
					xc: '董事会规则',
					zong: '突显股权是象征性，为组织经营服务',
					fenshu: '文本'
				}, {
					xc: '全面激励计划',
					zong: '股权在公司的作用，组织的责任与担当',
					fenshu: '文本'
				}, {
					xc: '中华人民共和国公司法',
					zong: '股权解释，组织和股东的权益和义务',
					fenshu: '法规条文'
				}, {
					xc: '年度目标达成方案',
					zong: '股圈目标分解以及完成的方向性活动',
					fenshu: '文本'
				}, {
					xc: '项目达成方案',
					zong: '股权从个案开始，体现股权的长期效果',
					fenshu: '文本'
				}, {
					xc: '目标绩效与考核方案',
					zong: '保障股东更稳定、组织持续发展',
					fenshu: '文本'
				}, {
					xc: '------',
					zong: '依组织过去、现状、未来发展进行增减',
					fenshu: ''
				}],
				biao3: [{
					xc: '服务/项目六宫格品牌定位法',
					zong: '决定企业方向与股权生命持续性',
					fenshu: '分析表'
				}, {
					xc: '合伙人测评',
					zong: '股权牢固的基础，投资可靠性保证。',
					fenshu: '软件'
				}, {
					xc: '合伙人要素评估',
					zong: '股权分配公平性、激励的高效性',
					fenshu: '评估表'
				}, {
					xc: '股权5D新赛道启动仪式',
					zong: '股权：造势、宣传、保障、激励、提升',
					fenshu: '流程'
				}, {
					xc: '战略设计—公司名称',
					zong: '行业有关、减少推广费和节省推广时间',
					fenshu: '高端生态'
				}, {
					xc: '战略设计—产品品牌',
					zong: '使用对象有关，消费者认知和品牌下沉',
					fenshu: '亲和、有磁场'
				}, {
					xc: '战略设计—产品渠道',
					zong: '快速铺垫销售管道，变现和销售增长',
					fenshu: '门店、代理'
				}, {
					xc: '战略设计—给客户创造价值',
					zong: '快速增长、盈利快，激发股东认同',
					fenshu: '刚需、必须'
				}, {
					xc: '股东个人尽职调查',
					zong: '画像形成，关键人股份分配合理性',
					fenshu: '表单'
				}, {
					xc: '股权结构',
					zong: '明确股权分配，了解过去、未来股权状',
					fenshu: '分配表'
				}, {
					xc: '商业计划书',
					zong: '吸引投资及内部关键人才，明确方向',
					fenshu: '指导方案'
				}, {
					xc: '股权九条红线运用表',
					zong: '创始人维护自己的正当权力，经营保障',
					fenshu: '提炼表'
				}, {
					xc: '对赌方案',
					zong: '确保入股股东的权益有一个安全的保障',
					fenshu: '方案表'
				}, {
					xc: 'AB股运用方案',
					zong: '创始人股权合规保障，促进组织发展',
					fenshu: '法规条文'
				}, {
					xc: '干股激励协议书',
					zong: '保证干股中管理、技术关键人潜力发挥',
					fenshu: '文本'
				}, {
					xc: '新进高管股权激励办法',
					zong: '引进合适人才，解决组织经营发展问题',
					fenshu: '文本'
				}, {
					xc: '保密协议',
					zong: '解决股权不便公开机密的保密性措施',
					fenshu: '文本'
				}, {
					xc: '竞业协议',
					zong: '避免内股东特权损害公司利益（20%）',
					fenshu: '文本'
				}, {
					xc: '股权激励计划管理制度',
					zong: '将股权激励与经营管理的融合目标管理',
					fenshu: '文本'
				}, {
					xc: '激励对象承诺书',
					zong: '确保参与股东和公司的遵循的准则',
					fenshu: '文本'
				}, {
					xc: '激励对象行权或解锁申请书',
					zong: '股权股份得到尊重，股权行权规范化',
					fenshu: '文本'
				}, {
					xc: '股东激励大会',
					zong: '股东承诺和结果认可，引领他人参与',
					fenshu: '文本'
				}, {
					xc: '公司章程',
					zong: '公司成立的法规性、可操作性',
					fenshu: '文本'
				}, {
					xc: '公司章程修改建议书',
					zong: '体现股权在章程中权威性及法律性',
					fenshu: '文本'
				}, {
					xc: '《股权赠与协议》',
					zong: '股权“稀释”的规范性和法律重要性',
					fenshu: '文本'
				}, {
					xc: '股东进入、分红及退出机制',
					zong: '保障公司在一定时间内健康运行',
					fenshu: '文本'
				}, {
					xc: '股权计划设计方案',
					zong: '股权构想和现实差距与解决问题的方法',
					fenshu: '文本'
				}, {
					xc: '董事会规则',
					zong: '突显股权是象征性，为组织经营服务',
					fenshu: '文本'
				}, {
					xc: '全面激励计划',
					zong: '股权在公司的作用，组织的责任与担当',
					fenshu: '文本'
				}, {
					xc: '中华人民共和国公司法',
					zong: '股权解释，组织和股东的权益和义务',
					fenshu: '法规条文'
				}, {
					xc: '年度目标达成方案',
					zong: '股圈目标分解以及完成的方向性活动',
					fenshu: '文本'
				}, {
					xc: '项目达成方案',
					zong: '股权从个案开始，体现股权的长期效果',
					fenshu: '文本'
				}, {
					xc: '目标绩效与考核方案',
					zong: '保障股东更稳定、组织持续发展',
					fenshu: '文本'
				}, {
					xc: '------',
					zong: '依组织过去、现状、未来发展进行增减',
					fenshu: ''
				}],
				biao4: [{
					xc: '服务/项目六宫格品牌定位法',
					zong: '决定企业方向与股权生命持续性',
					fenshu: '分析表'
				}, {
					xc: '合伙人测评',
					zong: '股权牢固的基础，投资可靠性保证。',
					fenshu: '软件'
				}, {
					xc: '中小企业股权配置七解码',
					zong: '股权分配科学性、公平性、高效性',
					fenshu: '评估表'
				}, {
					xc: '股权5D新赛道启动仪式',
					zong: '股权：造势、宣传、保障、激励、提升',
					fenshu: '流程'
				}, {
					xc: '战略设计—公司名称',
					zong: '行业有关、减少推广费和节省推广时间',
					fenshu: '高端生态'
				}, {
					xc: '战略设计—产品品牌',
					zong: '使用对象有关，消费者认知和品牌下沉',
					fenshu: '亲和、有磁场'
				}, {
					xc: '战略设计—产品渠道',
					zong: '快速铺垫销售管道，变现和销售增长',
					fenshu: '门店、代理'
				}, {
					xc: '战略设计—给客户创造价值',
					zong: '快速增长、盈利快，激发股东认同',
					fenshu: '刚需、必须'
				}, {
					xc: '股东个人尽职调查',
					zong: '画像形成，关键人股份分配合理性',
					fenshu: '表单'
				}, {
					xc: '股权设计—股改',
					zong: '产业清晰、节省个人所得税、资金调配',
					fenshu: '结构图'
				}, {
					xc: '商业计划书',
					zong: '吸引投资及内部关键人才，明确方向',
					fenshu: '指导方案'
				}, {
					xc: '股权九条红线运用表',
					zong: '创始人维护自己的正当权力，经营保障',
					fenshu: '提炼表'
				}, {
					xc: '激励兑现承诺书',
					zong: '股东和公司得准则，优秀人才得到回报',
					fenshu: '方案表'
				}, {
					xc: 'AB股运用方案',
					zong: '创始人股权合规保障，促进组织发展',
					fenshu: '法规条文'
				}, {
					xc: '干股（管理）激励协议书',
					zong: '保证干股中管理、技术关键人潜力发挥',
					fenshu: '文本'
				}, {
					xc: '管理层绩效考核办法',
					zong: '突显股权激励，股权与管理效果融合',
					fenshu: '文本'
				}, {
					xc: '干股（员工）股权激励协议书',
					zong: '保证员工与公司得利益得到公平对待',
					fenshu: '文本'
				}, {
					xc: '竞业协议',
					zong: '避免内股东特权损害公司利益（20%）',
					fenshu: '文本'
				}, {
					xc: '股权激励计划管理制度',
					zong: '将股权激励与经营管理的融合目标管理',
					fenshu: '文本'
				}, {
					xc: '激励对象承诺书',
					zong: '确保参与股东和公司的遵循的准则',
					fenshu: '文本'
				}, {
					xc: '激励对象行权或解锁申请书',
					zong: '股权股份得到尊重，股权行权规范化',
					fenshu: '文本'
				}, {
					xc: '股东激励大会',
					zong: '股东承诺和结果认可，引领他人参与',
					fenshu: '文本'
				}, {
					xc: '公司章程',
					zong: '公司成立的法规性、可操作性',
					fenshu: '文本'
				}, {
					xc: '公司章程修改建议书',
					zong: '体现股权在章程中权威性及法律性',
					fenshu: '文本'
				}, {
					xc: '《股权赠与协议》',
					zong: '股权“稀释”的规范性和法律重要性',
					fenshu: '文本'
				}, {
					xc: '股东进入、分红及退出机制',
					zong: '保障公司在一定时间内健康运行',
					fenshu: '文本'
				}, {
					xc: '股权计划设计方案',
					zong: '股权构想和现实差距与解决问题的方法',
					fenshu: '文本'
				}, {
					xc: '董事会规则',
					zong: '突显股权是象征性，为组织经营服务',
					fenshu: '文本'
				}, {
					xc: '全面激励计划',
					zong: '股权在公司的作用，组织的责任与担当',
					fenshu: '文本'
				}, {
					xc: '中华人民共和国公司法',
					zong: '股权解释，组织和股东的权益和义务',
					fenshu: '法规条文'
				}, {
					xc: '年度目标达成方案',
					zong: '股圈目标分解以及完成的方向性活动',
					fenshu: '文本'
				}, {
					xc: '项目达成方案',
					zong: '股权从个案开始，体现股权的长期效果',
					fenshu: '文本'
				}, {
					xc: '目标绩效与考核方案',
					zong: '保障股东更稳定、组织持续发展',
					fenshu: '文本'
				}, {
					xc: '------',
					zong: '依组织过去、现状、未来发展进行增减',
					fenshu: ''
				}],
				biao5: [{
					xc: '服务/项目六宫格品牌定位法',
					zong: '决定企业方向与股权生命持续性',
					fenshu: '分析表'
				}, {
					xc: '合伙人测评',
					zong: '股权牢固的基础，投资可靠性保证。',
					fenshu: '软件'
				}, {
					xc: '中小企业股权配置七解码',
					zong: '股权分配科学性、公平性、高效性',
					fenshu: '评估表'
				}, {
					xc: '股权5D新赛道启动仪式',
					zong: '股权：造势、宣传、保障、激励、提升',
					fenshu: '流程'
				}, {
					xc: '战略设计—公司名称',
					zong: '行业有关、减少推广费和节省推广时间',
					fenshu: '高端生态'
				}, {
					xc: '战略设计—产品品牌',
					zong: '使用对象有关，消费者认知和品牌下沉',
					fenshu: '亲和、有磁场'
				}, {
					xc: '战略设计—产品渠道',
					zong: '快速铺垫销售管道，变现和销售增长',
					fenshu: '门店、代理'
				}, {
					xc: '战略设计—给客户创造价值',
					zong: '快速增长、盈利快，激发股东认同',
					fenshu: '刚需、必须'
				}, {
					xc: '股东个人尽职调查',
					zong: '画像形成，关键人股份分配合理性',
					fenshu: '表单'
				}, {
					xc: '股权设计—股改',
					zong: '产业清晰、节省个人所得税、资金调配',
					fenshu: '结构图'
				}, {
					xc: '商业计划书',
					zong: '吸引投资及内部关键人才，明确方向',
					fenshu: '指导方案'
				}, {
					xc: '股权九条红线运用表',
					zong: '创始人维护自己的正当权力，经营保障',
					fenshu: '提炼表'
				}, {
					xc: '激励兑现承诺书',
					zong: '股东和公司得准则，优秀人才得到回报',
					fenshu: '方案表'
				}, {
					xc: 'AB股运用方案',
					zong: '创始人股权合规保障，促进组织发展',
					fenshu: '法规条文'
				}, {
					xc: '干股（管理）激励协议书',
					zong: '保证干股中管理、技术关键人潜力发挥',
					fenshu: '文本'
				}, {
					xc: '管理层绩效考核办法',
					zong: '突显股权激励，股权与管理效果融合',
					fenshu: '文本'
				}, {
					xc: '干股（员工）股权激励协议书',
					zong: '保证员工与公司得利益得到公平对待',
					fenshu: '文本'
				}, {
					xc: '竞业协议',
					zong: '避免内股东特权损害公司利益（20%）',
					fenshu: '文本'
				}, {
					xc: '股权激励计划管理制度',
					zong: '将股权激励与经营管理的融合目标管理',
					fenshu: '文本'
				}, {
					xc: '激励对象承诺书',
					zong: '确保参与股东和公司的遵循的准则',
					fenshu: '文本'
				}, {
					xc: '激励对象行权或解锁申请书',
					zong: '股权股份得到尊重，股权行权规范化',
					fenshu: '文本'
				}, {
					xc: '股东激励大会',
					zong: '股东承诺和结果认可，引领他人参与',
					fenshu: '文本'
				}, {
					xc: '公司章程',
					zong: '公司成立的法规性、可操作性',
					fenshu: '文本'
				}, {
					xc: '公司章程修改建议书',
					zong: '体现股权在章程中权威性及法律性',
					fenshu: '文本'
				}, {
					xc: '《股权赠与协议》',
					zong: '股权“稀释”的规范性和法律重要性',
					fenshu: '文本'
				}, {
					xc: '股东进入、分红及退出机制',
					zong: '保障公司在一定时间内健康运行',
					fenshu: '文本'
				}, {
					xc: '股权计划设计方案',
					zong: '股权构想和现实差距与解决问题的方法',
					fenshu: '文本'
				}, {
					xc: '董事会规则',
					zong: '突显股权是象征性，为组织经营服务',
					fenshu: '文本'
				}, {
					xc: '全面激励计划',
					zong: '股权在公司的作用，组织的责任与担当',
					fenshu: '文本'
				}, {
					xc: '中华人民共和国公司法',
					zong: '股权解释，组织和股东的权益和义务',
					fenshu: '法规条文'
				}, {
					xc: '年度目标达成方案',
					zong: '股圈目标分解以及完成的方向性活动',
					fenshu: '文本'
				}, {
					xc: '项目达成方案',
					zong: '股权从个案开始，体现股权的长期效果',
					fenshu: '文本'
				}, {
					xc: '目标绩效与考核方案',
					zong: '保障股东更稳定、组织持续发展',
					fenshu: '文本'
				}, {
					xc: '------',
					zong: '依组织过去、现状、未来发展进行增减',
					fenshu: ''
				}],
				biao6: [{
					xc: '服务/项目六宫格品牌定位法',
					zong: '决定企业方向与股权生命持续性',
					fenshu: '分析表'
				}, {
					xc: '合伙人测评',
					zong: '股权牢固的基础，投资可靠性保证。',
					fenshu: '软件'
				}, {
					xc: '中小企业股权配置七解码',
					zong: '股权分配科学性、公平性、高效性',
					fenshu: '评估表'
				}, {
					xc: '股权5D新赛道启动仪式',
					zong: '股权：造势、宣传、保障、激励、提升',
					fenshu: '流程'
				}, {
					xc: '战略设计—公司名称',
					zong: '行业有关、减少推广费和节省推广时间',
					fenshu: '高端生态'
				}, {
					xc: '战略设计—产品品牌',
					zong: '使用对象有关，消费者认知和品牌下沉',
					fenshu: '亲和、有磁场'
				}, {
					xc: '战略设计—产品渠道',
					zong: '快速铺垫销售管道，变现和销售增长',
					fenshu: '门店、代理'
				}, {
					xc: '战略设计—给客户创造价值',
					zong: '快速增长、盈利快，激发股东认同',
					fenshu: '刚需、必须'
				}, {
					xc: '股东个人尽职调查',
					zong: '画像形成，关键人股份分配合理性',
					fenshu: '表单'
				}, {
					xc: '股权设计—股改',
					zong: '产业清晰、节省个人所得税、资金调配',
					fenshu: '结构图'
				}, {
					xc: '商业计划书',
					zong: '吸引投资及内部关键人才，明确方向',
					fenshu: '指导方案'
				}, {
					xc: '股权九条红线运用表',
					zong: '创始人维护自己的正当权力，经营保障',
					fenshu: '提炼表'
				}, {
					xc: '激励兑现承诺书',
					zong: '股东和公司得准则，优秀人才得到回报',
					fenshu: '方案表'
				}, {
					xc: 'AB股运用方案',
					zong: '创始人股权合规保障，促进组织发展',
					fenshu: '法规条文'
				}, {
					xc: '干股（管理）激励协议书',
					zong: '保证干股中管理、技术关键人潜力发挥',
					fenshu: '文本'
				}, {
					xc: '管理层绩效考核办法',
					zong: '突显股权激励，股权与管理效果融合',
					fenshu: '文本'
				}, {
					xc: '干股（员工）股权激励协议书',
					zong: '保证员工与公司得利益得到公平对待',
					fenshu: '文本'
				}, {
					xc: '竞业协议',
					zong: '避免内股东特权损害公司利益（20%）',
					fenshu: '文本'
				}, {
					xc: '股权激励计划管理制度',
					zong: '将股权激励与经营管理的融合目标管理',
					fenshu: '文本'
				}, {
					xc: '激励对象承诺书',
					zong: '确保参与股东和公司的遵循的准则',
					fenshu: '文本'
				}, {
					xc: '激励对象行权或解锁申请书',
					zong: '股权股份得到尊重，股权行权规范化',
					fenshu: '文本'
				}, {
					xc: '股东激励大会',
					zong: '股东承诺和结果认可，引领他人参与',
					fenshu: '文本'
				}, {
					xc: '公司章程',
					zong: '公司成立的法规性、可操作性',
					fenshu: '文本'
				}, {
					xc: '公司章程修改建议书',
					zong: '体现股权在章程中权威性及法律性',
					fenshu: '文本'
				}, {
					xc: '《股权赠与协议》',
					zong: '股权“稀释”的规范性和法律重要性',
					fenshu: '文本'
				}, {
					xc: '股东进入、分红及退出机制',
					zong: '保障公司在一定时间内健康运行',
					fenshu: '文本'
				}, {
					xc: '股权计划设计方案',
					zong: '股权构想和现实差距与解决问题的方法',
					fenshu: '文本'
				}, {
					xc: '董事会规则',
					zong: '突显股权是象征性，为组织经营服务',
					fenshu: '文本'
				}, {
					xc: '全面激励计划',
					zong: '股权在公司的作用，组织的责任与担当',
					fenshu: '文本'
				}, {
					xc: '中华人民共和国公司法',
					zong: '股权解释，组织和股东的权益和义务',
					fenshu: '法规条文'
				}, {
					xc: '年度目标达成方案',
					zong: '股圈目标分解以及完成的方向性活动',
					fenshu: '文本'
				}, {
					xc: '项目达成方案',
					zong: '股权从个案开始，体现股权的长期效果',
					fenshu: '文本'
				}, {
					xc: '目标绩效与考核方案',
					zong: '保障股东更稳定、组织持续发展',
					fenshu: '文本'
				}, {
					xc: '------',
					zong: '依组织过去、现状、未来发展进行增减',
					fenshu: ''
				}]
			}
		},
		created() {
			this.urls()
			this.pingxe()
			this.an()
			this.baog()
			this.getNowDate()
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				this.$nextTick(() => {
					this.ec();
				});
			},
			urls() {
				let url = window.location.href
				let urlCode = url.substring(url.indexOf("=") + 1)
				this.urlCode = urlCode
			},
			pingxe() {
				let that = this
				this.$axios({
					method: "get",
					url: indexurl + "/index.php/api/index/getVisitorInfo?key=" + that.urlCode,
					data: {}
				}).then(res => {
					let cp = res.data.data
					if (cp.enterprise_years == '经营3年以上' || cp.enterprise_years == '经营3年以下') {
						cp.ey = '经营'
					} else {
						cp.ey = cp.enterprise_years
					}
					that.cepingren = cp
				})
			},
			getNowDate() {
				let date = new Date();
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let day = date.getDate();
				month = month < 10 ? '0' + month : month
				day = day < 10 ? '0' + day : day
				let time = `${year}年${month}月${day}`
				this.timeaa = time
			},
			an() {
				loading = this.$loading({
					lock: true,
					text: "上传中，请稍后",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)",
					customClass: 'jiaz'
				});
				let that = this
				this.$axios({
					method: "GET",
					url: indexurl + "/index.php/api/index/getResult?key=" + that.urlCode,
					data: {}
				}).then(res => {
					let list = []
					let lists = []
					let duan = res.data.data.test_result
					duan.map(item => {
						if (item.xm == '战略题') {
							list.push(item)
						} else {
							lists.push(item)
						}
					})
					let lao = 0
					let ding = 0
					let pei = 0
					let ming = 0
					let mu = 0
					lists.map(item => {
						if (item.xm == '老板格局') {
							lao = lao + Number(item.fenshu)
						}
						if (item.xm == '定位方向') {
							ding = ding + Number(item.fenshu)
						}
						if (item.xm == '配置股份') {
							pei = pei + Number(item.fenshu)
						}
						if (item.xm == '明确资产') {
							ming = ming + Number(item.fenshu)
						}
						if (item.xm == '目标绩效') {
              console.log(item.fenshu)
							mu = mu + Number(item.fenshu)
						}
					})
					let cl = [{
						xm: '老板格局',
						fenshu: lao.toFixed(2),
						zong: '30'
					}, {
						xm: '定位方向',
						fenshu: ding.toFixed(2),
						zong: '30'
					}, {
						xm: '配置股份',
						fenshu: pei.toFixed(2),
						zong: '20'
					}, {
						xm: '明确资产',
						fenshu: ming.toFixed(2),
						zong: '10'
					}, {
						xm: '目标绩效',
						fenshu: mu.toFixed(2),
						zong: '10'
					}]
					that.clists = cl
					let et = []
					let ef = []
					let ez = []
					cl.map(item => {
						et.push(item.xm)
						ef.push(item.fenshu)
						ez.push(item.zong)
					})
					var chartDom = document.getElementById('ecs');
					var myChart = echarts.init(chartDom);
					var option;
					option = {
						title: {
							text: '股权5D战术诊断折线图',
							fontWeight: 'bolder',
							left: 'center',
						},
						xAxis: {
							type: 'category',
							data: et
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: ef,
							type: 'line',
						}, {
							data: ez,
							type: 'line',
						}]
					}
					option && myChart.setOption(option);
					lists.map((item, index) => {
						const maxValue = Math.max(...Object.values(item.xx_json));
						return item.zong = maxValue
					})

					lists.map(item => {
						if (item.zong == item.fenshu) {
							return item.type = '保持'
						} else {
							return item.type = '学习《股权5D新赛道布局工具包》'
						}
					})
					list.map(item => {
						if (item.xc == '老板格局') {
							return item.zong = 30
						}
						if (item.xc == '定位方向') {
							return item.zong = 30
						}
						if (item.xc == '配置股份') {
							return item.zong = 20
						}
						if (item.xc == '明确资产') {
							return item.zong = 10
						}
						if (item.xc == '目标绩效') {
							return item.zong = 10
						}
					})
					let zongf = 0
					lists.map(item => {
						zongf = Number(item.fenshu) + zongf
					})
					let zongfs = zongf.toFixed(2)
					that.zong = zongfs
					console.log(lists, 'dfghjkl')
					that.dlist = list
					that.clist = lists
					let ct = []
					let tk = false
					list.map(item => {
						if (item.fenshu == 0) {
							tk = true
							ct.push(item.xc)
						}
					})
					let s = ct.toString();
					if (tk) {
						console.log(that.cepingren.enterprise_years, 'that.cepingren.enterprise_years')
						if (that.cepingren.enterprise_years == '初创(设想)') {
							this.$axios({
								method: "GET",
								url: indexurl + "/index.php/api/index/getstatus?key=" + that.urlCode +
									'&status=2&ct=' + s,
								data: {}
							}).then(ress => {
								that.text = ress.data.data
							})
						} else {
							this.$axios({
								method: "GET",
								url: indexurl + "/index.php/api/index/getstatus?key=" + that.urlCode +
									'&status=4&ct=' + s,
								data: {}
							}).then(ress => {
								that.text = ress.data.data
							})
						}
					} else {
						if (that.cepingren.enterprise_years == '初创(设想)') {
							this.$axios({
								method: "GET",
								url: indexurl + "/index.php/api/index/getstatus?key=" + that.urlCode +
									'&status=1',
								data: {}
							}).then(ress => {
								that.text = ress.data.data
							})
						} else {
							this.$axios({
								method: "GET",
								url: indexurl + "/index.php/api/index/getstatus?key=" + that.urlCode +
									'&status=3',
								data: {}
							}).then(ress => {
								that.text = ress.data.data
							})
						}
					}
					var chartDom = document.getElementById('ec');
					var myChart = echarts.init(chartDom);
					var option;
					let listss = []
					let fen = []
					let fens = []
					list.map(item => {
						listss.push(item.xc)
						fen.push(item.fenshu)
						fens.push(item.zong)
					})
					option = {
						title: {
							text: '股权5D战略诊断折线图',
							fontWeight: 'bolder',
							left: 'center',
						},
						xAxis: {
							type: 'category',
							data: listss
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: fen,
							type: 'line',
						}, {
							data: fens,
							type: 'line',
						}]
					}
					option && myChart.setOption(option);
				})
				this.generate()
			},
			ec() {

			},
			generate(val = true, download = false) {
				this.$nextTick(() => {
					setTimeout(() => {
						window.scrollTo(0,
							0); //这行代码很重要，它让页面的滚动条跳到了最上方如果点击打印按钮的时候,滚动条没有在最上方,打印内容会是不完整的,体验也会差
						let title = "个人报告"
						this.getPdf(title, download =
								false) //download：false为不下载，这里调用了刚刚引用的全局函数，.then得到的值是base64位的pdf文件
							.then((res) => {
								console.log(res);
								if (val) {
									this.UploadPdf(res);
								} else {}
							});
					}, 8000);
				});
			},
			UploadPdf(res) {
				let that = this;
				let pdfBase64Str = res;
				let title = "个人报告"
				let myfile = this.dataURLtoFile(pdfBase64Str, title + ".pdf"); //调用一下下面的转文件流函数
				let formdata = new FormData();
				formdata.append("file", myfile); // 文件对象
				console.log(myfile, 'myfile')
				this.$axios.post(indexurl + '/index.php/api/common/upload', formdata)
					.then((res) => {
						that.upurl(res.data.data.url)
						if (res.data.data.fullurl) {
							loading.close()
							this.$message({
								message: `提交成功，需查看报告，请联系管理员。`,
								type: 'success',
								duration: 0,
								showClose: true,
							});
						} else {
							this.$message({
								message: `数据提交失败`,
								type: 'error',
								duration: 0,
								showClose: true
							});
						}
					})
			},
			upurl(url) {
				let that = this
				this.$axios({
					method: "POST",
					url: indexurl + '/index.php/api/index/updateResult',
					data: {
						key: that.urlCode,
						file_url: url
					}
				}).then((res) => {})
			},
			dataURLtoFile(dataurl, filename) {
				let arr = dataurl.split(","),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new File([u8arr], filename, {
					type: mime
				});
			},
			baog() {
				let that = this
				this.$axios({
					method: "GET",
					url: indexurl + '/index.php/api/index/getConfig?key=jielun',
					data: {}
				}).then((res) => {})
			},
		}
	}
</script>
<style scoped>
	.tubiao {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}

	.t_left {
		width: 35%;
	}

	.export {
		/* padding: 120px; */
		width: 1920px;
	}

	.wei {
		height: 722mm;
		width: 100%;
		background: url("../../../static/image/wei.jpg") no-repeat;
		background-position: center bottom;
		background-size: 100% 100%;
	}

	.home {
		height: 722mm;
		width: 100%;
		background: url("../../../static/image/home.jpg") no-repeat;
		background-position: center bottom;
		background-size: 100% 100%;
		position: relative;
	}

	.com-x {
		position: absolute;
		top: 65%;
		left: 50%;
		transform: translateX(-50%);
		font-size: 64px;
		font-weight: bold;
	}

	.com-span1 {
		display: inline-block;
		padding: 0 10px;
		width: 400px;
		border-bottom: 1px solid #000;
		font-size: 36px;
		text-align: center;
	}

	.q {
		letter-spacing: 16px;
	}

	.z {}

	.t {
		letter-spacing: 96px;
	}

	.ctubiao {
		height: calc(722mm - 240px);
		padding: 120px;
	}

	.t1 {
		width: 320px;
		display: inline-block;
		border-bottom: 1px solid #000;
	}

	.t2 {
		width: 160px;
		display: inline-block;
		border-bottom: 1px solid #000;
	}

	.t3 {
		width: 160px;
		display: inline-block;
		border-bottom: 1px solid #000;
	}

	.bte {
		font-size: 22px;
		margin-bottom: 8px;
	}

	.list>>>.el-table__header {
		width: 100% !important;
	}

	.list>>>.el-table__body {
		width: 100% !important;
	}

	.t_left>>>.cell {
		font-size: 24px;
	}

	.ctubiao>>>.cell {
		font-size: 24px;
	}

	.ctubiao .tubiao {
		margin-bottom: 60px;
	}

	.text span {
		font-size: 22px !important;
	}

	.toptile {
		font-size: 64px;
		text-align: center;
	}

	.ma {
		margin-bottom: 20px;
	}

	.custom-table-border {
		border: 1px solid #000000;
		/* 红色边框 */
		border-collapse: collapse;
		/* 边框合并 */
	}

	.custom-table-border .el-table__row {
		border-bottom: 1px solid #000000;
		/* 行的下边框 */
	}

	.custom-table-border .el-table__cell {
		border-right: 1px solid #000000;
		/* 单元格的右边框 */
	}

	.htitle {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: 200px;
		font-size: 72px;
		font-weight: bold;
    width: 100%;
    text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/Cha/index.vue